import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { CommonSection } from '@flightstats/component-lib';
import componentBase from '../../src/lib/component-base';
import { addMetaCanonical } from '../../shared/lib/meta-tags';
import MobileAppCallout from '../../shared/components/MobileAppCallout/MobileAppCallout';
import HomepageSearch from './components/Search';
import HomepageMarketing from './components/Marketing';
import FeaturesSection from './components/FeaturesSection';
import OTPWinnerSection from './components/OTPWinnerSection';

const mapHeadingToPrettyTitle = {
  features: 'Features of the Site',
  mobile: 'Mobile Applications for the Active Traveler',
  otpAwards: 'On-time Performance Service Awards',
};

const sections = [
  {
    heading: 'features',
    component: FeaturesSection,
  },
  {
    heading: 'otpAwards',
    component: OTPWinnerSection,
  },
  {
    heading: 'mobile',
    component: MobileAppCallout,
  },
  {
    heading: 'homepageMarketing',
    hideBorder: true,
    component: HomepageMarketing,
  },
];

@componentBase('Homepage')
class Homepage extends Component {
  static propTypes = {
    location: PropTypes.object,
  }

  metaTags = () => {
    const title = 'FlightStats - Global Flight Tracker, Status Tracking and Airport Information';
    const description = 'Global Flight Tracker and Travel Planning. Track real-time flight status, departures and arrivals, airport delays, and airport information.';
    const keywords = 'flight tracker, global flight status, flight status, airport information, airport delays, flight alerts, departures, arrivals';

    const metaWithoutCanonical = {
      title,
      meta: [
        { name: 'keywords', content: keywords },
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
      ],
    };
    const { location } = this.props;
    const pathname = location && location.pathname;
    return addMetaCanonical(metaWithoutCanonical, pathname);
  }

  render() {
    const {
      mediaBreakpoint = {},
      reportButtonPress,
    } = this.context;

    return (
      <div className='homepage-container'>
        <Helmet {...this.metaTags()} />
        <CommonSection hideBorder>
          <HomepageSearch {...this.props} />
        </CommonSection>
        {sections.map(section => (
          <CommonSection
            hideBorder={section.hideBorder}
            title={mapHeadingToPrettyTitle[section.heading]}
            key={`section-${section.heading}`}
          >
            <section.component
              {...this.props}
              mediaBreakpoint={mediaBreakpoint}
              reportButtonPress={reportButtonPress}
            />
          </CommonSection>
        ))}
      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./modules/Homepage/container.js